(() => {
  const rail = document.querySelector('[data-du-collection-filters]');
  if (!rail) return;

  if (rail.dataset.duResetUrl) {
    const target = new URL(rail.dataset.duResetUrl, window.location.href);
    if (target.origin === window.location.origin && target.href !== window.location.href) {
      window.location.replace(target.href);
    }
    return;
  }

  const disclosure = rail.querySelector('.du-cfilters__disclosure');
  if (!disclosure) return;
  const breakpoint = window.matchMedia('(min-width: 990px)');
  const update = () => {
    disclosure.open = breakpoint.matches || rail.dataset.duSelectedContext === 'true';
  };
  const initialize = () => {
    update();
    breakpoint.addEventListener('change', update);
  };
  if (document.readyState === 'complete') initialize();
  else window.addEventListener('load', initialize, { once: true });
})();
